<template>
  <div class="page-content">
    <div  :span="24" class="h100 overflow-x-y">
      <div v-if="!disabled" class="pb8 clearfix">
        <el-button  class="float-right" style="margin-left:8px;" icon="el-icon-circle-plus-outline" type="primary" @click="addRowData()">
          新增
        </el-button>
        <el-button  class="float-right" style="margin-left:8px;" icon="el-icon-circle-plus-outline" type="primary" @click="batchAddData()">
          批量添加
        </el-button>
        <el-button  class="float-right" style="margin-left:8px;" icon="el-icon-circle-plus-outline" type="primary" @click="fastAddData()">
          快速添加
        </el-button>
      </div>

      <el-form ref="formRef" :model="formData">
        <!-- 表格 -->
        <EdmCustomTable
          ref="customTable"
          :show-pagination="false"
          :loading="tableLoading"
          :table-data="formData.tableData"
          row-key="columnName"
        >
          <el-table-column :width="'auto'" :min-width="200" :show-overflow-tooltip="true">
            <template  slot="header">
              <div  :class="{ 'asterisk--layout': !disabled }">
                <span>表格列key</span>
              </div>
            </template>
            <template slot-scope="scope">
              <!-- 编辑态 -->
              <el-form-item
                v-if="!disabled"
                :prop="`tableData[${scope.$index}].columnName`"
                :rules="formRules.columnName"
              >
                <el-input
                  v-model="scope.row.columnName"
                  :placeholder="$t('public.pleaseEnter')"
                ></el-input>
              </el-form-item>
              <!-- 查看态 -->
              <template v-else>
                <span>{{scope.row.columnName}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column :width="'auto'" :min-width="200" :show-overflow-tooltip="true">
            <template  slot="header">
              <div :class="{ 'asterisk--layout': !disabled }">
                <span>表格列名称</span>
              </div>
            </template>
            <template slot-scope="scope">
              <!-- 编辑态 -->
              <el-form-item
                v-if="!disabled"
                :prop="`tableData[${scope.$index}].columnTitle`"
                :rules="formRules.columnTitle"
              >
                <el-input
                  v-model="scope.row.columnTitle"
                  :placeholder="$t('public.pleaseEnter')"
                ></el-input>
              </el-form-item>
              <!-- 查看态 -->
              <template v-else>
                <span>{{scope.row.columnTitle}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column :width="'200'" label="描述" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <!-- 编辑态 -->
              <el-form-item  v-if="!disabled" >
                <el-input
                  v-model="scope.row.description"
                  type="textarea"
                  show-word-limit
                  resize="none"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  :placeholder="$t('public.pleaseEnter')"
                  :maxlength="$getInputMaxLimitConst('limit200')"
                ></el-input>
              </el-form-item>
              <!-- 查看态 -->
              <template v-else>
                <span>{{scope.row.description}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column  v-if="!disabled" fixed="right" :label="$t('public.operation')"  width="180">
            <template slot-scope="scope">
              <span
                class="circle-button circle--delete"
                style="margin-right: 10px"
                @click="deleteRowData(scope.$index)"
              >
                <svg-icon icon-class="sort-del"></svg-icon>
              </span>
              <span
                class="circle-button circle--primary"
                style="margin-right: 10px"
                @click="addRowData()"
              >
                <svg-icon icon-class="sort-add"></svg-icon>
              </span>

              <span
                :class="[
                  'circle-button',
                  'circle--primary',
                  {
                    'is-disabled': scope.$index === 0
                  }
                ]"
                style="margin-right: 10px"
                :disabled="scope.$index === 0"
                @click="upCode(scope.$index)"
              >
                <svg-icon icon-class="sort-up"></svg-icon>
              </span>
              <span
                :class="[
                  'circle-button',
                  'circle--primary',
                  {
                    'is-disabled': scope.$index === Number(formData.tableData.length) - 1
                  }
                ]"
                style="margin-right: 10px"
                :disabled="scope.$index === Number(formData.tableData.length) - 1"
                @click="downCode(scope.$index)"
              >
                <svg-icon icon-class="sort-down"></svg-icon>
              </span>
            </template>
          </el-table-column>
        </EdmCustomTable>
        <!-- /表格 -->
      </el-form>

      <!-- 表格删除确认框 -->
      <delete-dialog
        layout="left"
        :visible.sync="deleteDialogVisible"
        :content="deleteContent"
        :loading.sync="deleteLoading"
        @confirm="handleDeleteConfirm"
      />
      <!-- /表格删除确认框 -->
      <batch-table-add
        v-if="dialogFormVisible"
        :visible.sync="dialogFormVisible"
        @refresh="handleUpdateList"
      />
      <fast-table-add
        v-if="fastAddVisible"
        :visible.sync="fastAddVisible"
        :default-checked-keys = "formData.tableData"
        @confirm="handleUpdateList"
      />
    </div>
  </div>
</template>

<script>
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import BatchTableAdd from "./batch-table-add.vue";
import FastTableAdd from "./fast-table-add.vue";
export default {
  name: "ReportTableList",
  components: {
    DeleteDialog,
    BatchTableAdd,
    FastTableAdd
  },
  inject: ["sqldata"],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableLoading: false,
      formData: {
        tableData: []
      },
      formRules: {
        columnName: [
          {
            required: true,
            message: `请输入表格列key`,
            trigger: "blur"
          }
        ],
        columnTitle: [
          {
            required: true,
            message: `请输入表格列名称`,
            trigger: "blur"
          }
        ]
      },
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteContent: {
        title: "确定要移除吗？",
        description: "请谨慎操作"
      },
      deleteRows: -1,
      dialogFormVisible: false,
      fastAddVisible: false
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
    setData(data) {
      if (data && data.reportColumnConfigDTOList && data.reportColumnConfigDTOList.length) {
        this.$set(this.formData, "tableData", data.reportColumnConfigDTOList);
      }
    },
    // 新增
    addRowData() {
      if (this.validateForm()) {
        this.formData.tableData.push({
          columnName: "",
          columnTitle: "",
          description: ""
        });
      }
    },
    // 验证表单
    validateForm() {
      let pass = false;
      this.$refs.formRef.validate(valid => {
        if (valid) {
          pass = true;
        }
      });
      return pass;
    },
    // 删除
    deleteRowData(index) {
      this.deleteRows = index;
      this.deleteDialogVisible = true;
    },
    // 删除提交
    handleDeleteConfirm() {
      this.formData.tableData.splice(this.deleteRows, 1);
      this.deleteDialogVisible = false;
    },
    upCode(index) {
      if (index === 0) {
        return;
      }
      const newDynamic = [...this.formData.tableData];
      const temp = newDynamic[index];
      newDynamic[index] = newDynamic[index - 1];
      newDynamic[index - 1] = temp;
      this.$nextTick(() => {
        this.formData.tableData = [...newDynamic];
      });
    },

    downCode(index) {
      if (index === this.formData.tableData.length - 1) {
        return;
      }
      const newDynamic = [...this.formData.tableData];
      const temp = newDynamic[index];
      newDynamic[index] = newDynamic[index + 1];
      newDynamic[index + 1] = temp;
      this.$nextTick(() => {
        this.formData.tableData = [...newDynamic];
      });
    },
    batchAddData() {
      this.dialogFormVisible = true;
    },
    handleUpdateList(data) {
      const arr = [];
      data.forEach(item => {
        const hadData = this.formData.tableData.some(col => col.columnName === item.columnName);
        if (!hadData) {
          arr.push(item);
        }
      });
      this.formData.tableData = [...this.formData.tableData, ...arr];
    },
    fastAddData() {
      const data = this.sqldata() || {};
      if (data.originalSql && data.datasourceId) {
        this.fastAddVisible = true;
      } else {
        this.$message.warning("请检查sql和数据源是否都有值");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pb8{
  padding-bottom: 8px;
}
.asterisk--layout{
    transform: translateX(-12px);

    &::before{
      display: inline-block;
      margin-right: 3px;
      color: #f00;
      vertical-align: middle;
      content: "*";
    }
  }
.clear-mr--b{
  margin-bottom: 5px;
}
.text-color--green{
  color: #00b259;
  cursor: pointer;
}
.circle-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #d4d9e2;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  text-align: center;
  padding: 0px;
  color: #fff;
  background-color: #c6ccd7;
  border-color: #c6ccd7;
}
.is-disabled:hover {
  color: #c6ccd7;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #d4d9e2;
}
.circle--primary:hover {
  background-color: #00b259;
  border-color: #00b259;
}
.circle--delete:hover {
  background-color: #e60000;
  border-color: #e60000;
}
</style>
